import React from 'react'
import CheckoutCard from '../../components/molecules/CheckoutCard'
import CheckoutPayment from '../../components/molecules/CheckoutPayment'
import { connect } from 'react-redux'
import { Userdetails } from '../../actions/useraction'
import './Checkout.css'

function Checkout(props) {
    console.log('state data ===========', props.location.state)
    const checkoutData = props.location.state.data
    const Checkout = [
        {
            pdtName: checkoutData.category_id,
            pdtPrice: checkoutData.wprice,
            inv: checkoutData.common_invoice,
            additional_amount_1: checkoutData.additional_amount_1,
            additional_amount_2: checkoutData.additional_amount_2,
            additional_amount_3: checkoutData.additional_amount_3,
        },
    ]

    const Payment = [
        {
            Price: '$ ' + checkoutData.wprice,
            // Fee: '$ 250',
            // Tax: '$ 0',
            Total: '$ ' + checkoutData.wprice,
        },
    ]
    return (
        <div className="checkoutContainer d-flex justify-content-between">
            <div className="checkoutPdt">
                <p className="checkoutTitle">Checkout</p>
                {Checkout.map((data, index) => (
                    <CheckoutCard Name={data.pdtName} Price={data.pdtPrice} inv={data.inv} />
                ))}
            </div>
            <div className="paymentContainer">
                <p className="paymentTitle">Payment Details</p>
                {Checkout.map((data, index) => (
                    <CheckoutPayment
                        totalPrice={data.pdtPrice}
                        name={data.pdtName}
                        inv={data.inv}
                        additional_amount_1={data.additional_amount_1}
                        additional_amount_2={data.additional_amount_2}
                        additional_amount_3={data.additional_amount_3}
                        profile={props.userDetails.userdetails}
                        // conFee={data.Fee}
                        // taxPrice={data.Tax}
                        // grandTotal={data.Total}
                    />
                ))}
            </div>
        </div>
    )
}
const mapDispatchToProps = (dispatch) => ({
    User: () => dispatch(Userdetails()),
})

const mapStateToProps = (state) => {
    return {
        userDetails: state.User,
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Checkout)
